import type React from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import { AssetsTooltipContent } from "app/pages/digital-suite/home-page/components/CustomAssets/AssetsTooltipContent/AssetsTooltipContent";
import { AssetType } from "app/pages/digital-suite/home-page/components/CustomAssets/types";

export const KeywordsListTooltipContent: React.FC = () => {
    const i18n = i18nFilter();

    return (
        <AssetsTooltipContent
            assetType={AssetType.KEYWORD_LIST}
            title={i18n("digitalmarketing.homepage.custom_assets.empty_state.tooltip.title.keywordLists")}
            videoUrl={"https://vimeo.com/436363559"}
            videoThumbnailSrc={"/images/custom-assets/keywords-list-info-thumbnail.png"}
            learnMoreUrl={"https://support.similarweb.com/hc/en-us/articles/360011016598-Create-a-Keyword-List"}
            onVideoOpen={() => {}}
        />
    );
};
